import { render, staticRenderFns } from "./AttendanceDates.vue?vue&type=template&id=1008a4d4&"
import script from "./AttendanceDates.vue?vue&type=script&lang=js&"
export * from "./AttendanceDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports